export const etatPanierCompleteAfterConnectProps = () => ({
  etatPanier: {
    type: Object,
    required: true
  }
})